import { useHistory } from 'app/api/HistoryApi';
import PageHeader from "../core/App/PageHeader";
import { Preloader } from 'llui';
import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Box, FormGroup, Heading, Input } from 'tombac';
import { ChevronSLeftIcon, ChevronSRightIcon } from 'tombac-icons';
import { PaginationContainer } from "../contracts/list/Pagination";
import useInput from "../users/details/hooks/useInput";
import { ActivityItem } from "./ActivityItem";
import "./HistoryPage.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function HistoryPage() {
  const [targetInput] = useInput('');
  const [initiatorInput] = useInput('');
  const [apiKeyInput] = useInput('');
  const [page, setPage] = useState(0);
  const historyPage = useHistory({
    apiKey: apiKeyInput.value || undefined,
    author: initiatorInput.value || undefined,
    debounceMs: 300,
    email: targetInput.value || undefined,
    page
  });
  if (historyPage instanceof Error) {
    throw new Error('Failed to fetch activity history');
  }
  useEffect(() => {
    setPage(0);
  }, [targetInput.value, initiatorInput.value]);
  if (historyPage === undefined) {
    return /*#__PURE__*/_jsxs("div", {
      className: "HistoryPage__loading",
      children: [/*#__PURE__*/_jsx(Preloader, {}), /*#__PURE__*/_jsx("div", {
        className: "HistoryPage__loading-text",
        children: "Loading activity history..."
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      transparent: true,
      "data-sentry-element": "PageHeader",
      "data-sentry-source-file": "HistoryPage.tsx",
      "data-sentry-element": "PageHeader",
      children: /*#__PURE__*/_jsx(Heading, {
        as: "h1",
        level: 3,
        $mb: "0sp",
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "HistoryPage.tsx",
        "data-sentry-element": "Heading",
        children: "Activity history"
      })
    }), ' ', /*#__PURE__*/_jsxs(Box, {
      $padding: "0 3sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "HistoryPage.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx("div", {
        className: "HistoryPage__filters",
        children: !historyPage.empty && /*#__PURE__*/_jsxs(PaginationContainer, {
          children: [/*#__PURE__*/_jsx(FormGroup, {
            htmlFor: "history-target-input",
            label: "Target",
            $mr: "2sp",
            children: /*#__PURE__*/_jsx(Input, {
              id: "history-target-input",
              placeholder: "Target",
              ...targetInput
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            htmlFor: "history-initiator-input",
            label: "Initiator",
            $mr: "2sp",
            children: /*#__PURE__*/_jsx(Input, {
              id: "history-initiator-input",
              placeholder: "Initiator",
              $background: "#fff",
              ...initiatorInput
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            htmlFor: "history-apikey-input",
            label: "API key",
            $mr: "2sp",
            children: /*#__PURE__*/_jsx(Input, {
              id: "history-apikey-input",
              placeholder: "API key",
              ...apiKeyInput
            })
          }), /*#__PURE__*/_jsx(ReactPaginate, {
            pageCount: historyPage?.totalPages,
            pageRangeDisplayed: 5,
            marginPagesDisplayed: 1,
            forcePage: page,
            containerClassName: "pagination",
            pageClassName: "pagination-item",
            pageLinkClassName: "pagination-link",
            activeClassName: "pagination-item--active",
            disabledClassName: "pagination-item--disabled",
            previousClassName: "pagination-item",
            nextClassName: "pagination-item",
            previousLinkClassName: "pagination-link ",
            nextLinkClassName: "pagination-link",
            breakClassName: "pagination-break",
            previousLabel: /*#__PURE__*/_jsx(ChevronSLeftIcon, {}),
            nextLabel: /*#__PURE__*/_jsx(ChevronSRightIcon, {}),
            onPageChange: v => setPage(v.selected)
          })]
        })
        // <Pagination
        //   page={page}
        //   itemCount={data?.totalElements}
        //   onPageChange={(page) => {
        //     setPage(page);
        //   }}
        // />
      }), historyPage.empty ? /*#__PURE__*/_jsx("div", {
        className: "HistoryPage__results HistoryPage__results--empty",
        children: "No results"
      }) : /*#__PURE__*/_jsxs("div", {
        className: "HistoryPage__results",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "ActivityItem__row ActivityItem__row--Head ActivityItem__row--disabled",
          children: [/*#__PURE__*/_jsx("div", {
            className: "ActivityItem__row-item",
            children: "Action"
          }), /*#__PURE__*/_jsx("div", {
            className: "ActivityItem__row-item",
            children: "Target"
          }), /*#__PURE__*/_jsx("div", {
            className: "ActivityItem__row-item",
            children: "Initiator"
          }), /*#__PURE__*/_jsx("div", {
            className: "ActivityItem__row-item",
            children: "Date"
          })]
        }), /*#__PURE__*/_jsx("div", {
          children: historyPage.content.map((item, i) => {
            return /*#__PURE__*/_jsx(ActivityItem, {
              item: item,
              showTarget: true
            }, i + item.timestamp);
          })
        })]
      })]
    })]
  });
}
export default HistoryPage;